<template>
  <section class="explore-services-section">
    <div class="container">
      <div class="section-header">
        <div class="section-tag">
          <i class="fas fa-star"></i>
          <span>{{ content.header.tag }}</span>
        </div>
        <h2>{{ content.header.title }}</h2>
      </div>
      
      <div class="services-slider swiper" ref="servicesSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(service, index) in content.services" :key="index">
            <div class="service-card">
              <div class="service-number">{{ service.number }}</div>
              <div class="service-content">
                <h3>{{ service.title }}</h3>
                <p>{{ service.description }}</p>
                <ul class="service-features">
                  <li v-for="(feature, featureIndex) in service.features" :key="featureIndex">{{ feature }}</li>
                </ul>
                <button class="learn-more-btn">
                  {{ service.buttonText }}
                  <i class="fas fa-arrow-right"></i>
                </button>
              </div>
              <div class="service-visual">
                <img :src="service.image" :alt="service.title" class="service-bg-image" />
                <div class="service-overlay"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- Navigation buttons -->
        <div class="swiper-button-next services-next"></div>
        <div class="swiper-button-prev services-prev"></div>
        <!-- Pagination -->
        <div class="swiper-pagination services-pagination"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue'

export default {
  name: 'AIMLItsServicesComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  setup() {
    const servicesSwiper = ref(null)

    onMounted(() => {
      initServicesSwiper()
    })

    const initServicesSwiper = () => {
      setTimeout(() => {
        const checkSwiper = () => {
          if (window.Swiper) {
            servicesSwiper.value = new window.Swiper('.services-slider', {
              loop: true,
              autoplay: {
                delay: 4000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: '.services-next',
                prevEl: '.services-prev',
              },
              pagination: {
                el: '.services-pagination',
                clickable: true,
              },
              breakpoints: {
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                }
              }
            });
          } else {
            setTimeout(checkSwiper, 100);
          }
        };
        checkSwiper();
      }, 500);
    }

    return {
      servicesSwiper
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Explore Our Services Section */
.explore-services-section {
  padding: 100px 0;
  background: linear-gradient(145deg, #0a0f1c, #1a2332);
  color: #fff;
}

.explore-services-section .section-header {
  text-align: center;
  margin-bottom: 80px;
}

.explore-services-section .section-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(251, 14, 118, 0.1);
  border: 1px solid rgba(251, 14, 118, 0.3);
  padding: 8px 20px;
  border-radius: 25px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #FB0E76;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.explore-services-section .section-tag i {
  font-size: 12px;
  color: #FB0E76;
}

.explore-services-section .section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  line-height: 1.2;
}

.services-slider {
  position: relative;
  padding: 0 60px;
}

.service-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.1);
  border-radius: 20px;
  padding: 40px;
  display: flex;
  align-items: center;
  gap: 40px;
  min-height: 400px;
  position: relative;
  overflow: hidden;
}

.service-number {
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 18px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.3);
}

.service-content {
  flex: 1;
  z-index: 2;
}

.service-content h3 {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  line-height: 1.3;
}

.service-content p {
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 30px;
}

.service-features {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.service-features li {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}

.service-features li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background: #FB0E76;
  border-radius: 50%;
}

.learn-more-btn {
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.learn-more-btn:hover {
  background: rgba(0, 0, 0, 0.9);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.learn-more-btn i {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.learn-more-btn:hover i {
  transform: translateX(2px);
}

.service-visual {
  flex: 1;
  height: 300px;
  position: relative;
  border-radius: 15px;
  overflow: hidden;
}

.service-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.service-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(251, 14, 118, 0.7), rgba(145, 6, 148, 0.7), rgba(246, 236, 79, 0.7));
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.service-card:hover .service-bg-image {
  transform: scale(1.1);
}

.service-card:hover .service-overlay {
  opacity: 0.6;
}

/* Services Swiper Navigation */
.services-next,
.services-prev {
  background: #F6EC4F;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  color: #000;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(246, 236, 79, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.services-next:hover,
.services-prev:hover {
  background: #FFD700;
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 8px 25px rgba(246, 236, 79, 0.4);
}

.services-prev {
  left: 10px;
}

.services-next {
  right: 10px;
}

.services-next:after,
.services-prev:after {
  font-family: 'Font Awesome 6 Free';
  font-weight: 900;
  font-size: 16px;
}

.services-prev:after {
  content: '\f053';
}

.services-next:after {
  content: '\f054';
}

/* Services Swiper Pagination */
.services-pagination {
  position: relative;
  margin-top: 40px;
  text-align: center;
}

.services-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background: rgba(255, 255, 255, 0.3);
  opacity: 1;
  margin: 0 5px;
  transition: all 0.3s ease;
}

.services-pagination .swiper-pagination-bullet-active {
  background: #F6EC4F;
  transform: scale(1.2);
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .explore-services-section {
    padding: 80px 0;
  }
  
  .section-header h2 {
    font-size: 36px;
  }
  
  .service-card {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
  
  .service-visual {
    height: 250px;
  }
  
  .services-slider {
    padding: 0 20px;
  }
  
  .services-prev {
    left: 5px;
  }
  
  .services-next {
    right: 5px;
  }
}

@media only screen and (max-width: 767px) {
  .section-header h2 {
    font-size: 28px;
  }
  
  .section-tag {
    font-size: 12px;
    padding: 6px 16px;
  }
  
  .service-card {
    padding: 30px 20px;
  }
  
  .service-content h3 {
    font-size: 24px;
  }
}
</style>
